module.exports = __webpack_public_path__ + "media/images/mobile/abouts/m_sw-cd4d77b5b833b6dadbfe9cf9ca8be427.png";